import React from "react";
import { Link } from "react-router-dom";
import "../styles/Hero.css";

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>
          Find Silence
          <br />
          In The Himalayas
        </h1>
        <p>
          Sacred retreats blending yoga, mountains,
          meditation and stillness.
        </p>

        <Link href="featured" className="explore-btn">
          Begin Your Journey
        </Link>
      </div>
    </section>
  );
}

export default Hero;

